import React, { useState, useEffect } from "react";
import Select from "react-select";
import { SiteVisitationMachine, SiteVisitationSteps, useSiteVisitation } from "../../../providers/SiteVisitationProvider";

const MachineInfo = (props: {
  selectSiteVisitationMachine: { [machineId: string]: SiteVisitationMachine };
  setCurrentStep: (step: number) => void;
  setFieldValue: any;
  jobId:any;
}) => {
  const {
    selectSiteVisitationMachine,
    setCurrentStep,
    setFieldValue,
    jobId,
  } = props;

  const {
    blendersDB,
    tubeShieldsDB,
    validateFields,
    validationErrors,
    updateMachineData,
    setSelectedMachine,
    selectedMachineDetails,
    cupHolderDB
  } = useSiteVisitation();

  const selectedMachine: any = selectSiteVisitationMachine;
  // 🔄 Load data from localStorage when component mounts

  useEffect(() => {
    if (!selectedMachine?.id) return;
    setSelectedMachine(selectedMachine.id, jobId);
  }, [selectedMachine, jobId]);

  const blenderDefaultValue = blendersDB.find(
    (b) => String(b.id) === String(selectedMachineDetails?.blenderId)
  )
    ? { label: blendersDB.find((b) => String(b.id) === String(selectedMachineDetails?.blenderId))?.title, value: selectedMachineDetails?.blenderId }
    : null;

  const tubeShieldDefaultValue = tubeShieldsDB.find(
    (t) => String(t.id) === String(selectedMachineDetails?.tubeShieldId)
  )
    ? { label: tubeShieldsDB.find((t) => String(t.id) === String(selectedMachineDetails?.tubeShieldId))?.name, value: selectedMachineDetails?.tubeShieldId }
    : null;
    const cupHolderDefaultValue = cupHolderDB.find(
      (b) => String(b.id) === String(selectedMachineDetails?.cupHolderId)
    )
      ? { label: cupHolderDB.find((b) => String(b.id) === String(selectedMachineDetails?.cupHolderId))?.title, value: selectedMachineDetails?.cupHolderId }
      : null;

  return (
    <div className="wo-form-section mt-8">
      <header className="header">
        <h2>Machines Information</h2>
      </header>
      <div className="flex justify-between items-center m-4">
        <div className="left-icon mt-4" onClick={() => setCurrentStep(SiteVisitationSteps.MACHINE_LIST)}>
          <i className="fa fa-arrow-left" aria-hidden="true"></i>
        </div>
      </div>

      <div className="machine-wrapper">
        <div className="mb-4 text-sm font-medium">
          <p><strong>Machine Name:</strong> {selectedMachine?.name || "N/A"}</p>
          <p><strong>Serial Number:</strong> {selectedMachine?.serialNumber || "N/A"}</p>
        </div>

        {/* Checkbox fields */}
        <div className="mt-8">
          {[
            { label: "Machine has Polyfuses", name: "isPolyFuses" },
            { label: "Made 4 smoothies", name: "made4Smoothies" },
            { label: "Machine Surface, Blender Bell Wiper, Bottom Wiper are clean", name: "cleanlinessCheck" },
            { label: "Machine Passed Getstatus", name: "getStatusPassed" },
            { label: "Flowmeter Activated", name: "flowmeterActivated" },
            { label: "Water level is calibrated with scale", name: "waterLevelCalibratedWithScale" },
            { label: "Replace filter", name: "replaceFilter" },
          ].map((item, idx) => (
            <div key={idx} className="d-flex justify-content-between align-items-center mb-3">
              <label className='wo-label fw-semibold'>{item.label}:</label>
              <div className="form-check form-switch form-check-custom">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={!!selectedMachineDetails?.[item.name]} // Reflect the stored value
                  onChange={(e) => {
                    updateMachineData(jobId, selectedMachine.id, item.name, e.target.checked); // Update localStorage
                   // setFieldValue(item.name, e.target.checked);
                  }}
                  name={item.name}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Sanitizer Level */}
        <div className="wo-form-section mt-8">
          <div className="d-flex align-items-center justify-content-between">
            <label className="wo-label required">Sanitizer Level:</label>
            <div>
              {["LOW", "MEDIUM", "HIGH"].map((level) => (
                <button
                  key={level}
                  type="button"
                  onClick={() => {
                    updateMachineData(jobId, selectedMachine.id, "sanitizerLevel", level); // Update localStorage
                    // setFieldValue("sanitizerLevel", level);
                    // setSelectedLevel(level); // Update state to reflect the change
                  }}
                  className={`btn responsive-btn me-2 ${
                    selectedMachineDetails['sanitizerLevel'] === level ? "btn-primary" : "btn-light text-dark"
                  }`}
                >
                  {level}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Blender dropdown */}
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3 mt-4">
          <label className="wo-label mb-2 mb-md-0 me-md-3 required">Blender:</label>
          <div className="flex-grow-1 w-100">
            <Select
              className="react-select"
              classNamePrefix="my-react-select"
              name="blender"
              placeholder=""
              options={blendersDB.map((b) => ({ value: b.id, label: b.title }))}
              value={blenderDefaultValue}
              onChange={(e: any) => {
                updateMachineData(jobId, selectedMachine.id, "blenderId", e.value); // Update localStorage
                // setFieldValue("blenderId", e.value);
              }}
            />
          </div>
        </div>

        {/* Tube Door Shield dropdown */}
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3 mt-4">
          <label className="wo-label mb-2 mb-md-0 me-md-3 required">Tube Door Shield:</label>
          <div className="flex-grow-1 w-100">
            <Select
              className="react-select"
              classNamePrefix="my-react-select"
              name="tubeShieldId"
              placeholder=""
              options={tubeShieldsDB.map((t) => ({ value: t.id, label: t.name }))}
              value={tubeShieldDefaultValue}
              onChange={(e: any) => {
                updateMachineData(jobId, selectedMachine.id, "tubeShieldId", e.value); // Update localStorage
               // setFieldValue("tubeShieldId", e.value);
              }}
            />
          </div>
        </div>
        {/* Cup Holder dropdown */}
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3 mt-4">
          <label className="wo-label mb-2 mb-md-0 me-md-3 required">Cup Holder:</label>
          <div className="flex-grow-1 w-100">
            <Select
              className="react-select"
              classNamePrefix="my-react-select"
              name="cupHolderId"
              placeholder=""
              options={cupHolderDB.map((t) => ({ value: t.id, label: t.title }))}
              value={cupHolderDefaultValue}
              onChange={(e: any) => {
                updateMachineData(jobId, selectedMachine.id, "cupHolderId", e.value); // Update localStorage
              }}
            />
          </div>
        </div>
        {/* Display validation errors */}
        {validationErrors[selectedMachine?.id] && (
          <div className="text-danger mt-3">
            {validationErrors[selectedMachine?.id].split(",").map((error, idx) => (
              <p key={idx}>{error.trim()}</p>
            ))}
          </div>
        )}

        {/* Finish Button */}
        <button
          className="btn btn-primary float-end mt-4"
          type="button"
          onClick={() => {
            if (validateFields(selectedMachine?.id, selectedMachineDetails)) {
              updateMachineData(jobId, selectedMachine.id, "finishWorkOnMachine", true); 
              setCurrentStep(SiteVisitationSteps.MACHINE_LIST);
            }
          }}  
        >
          Finish <i className="fa fa-check-circle ms-2" aria-hidden="true"></i>
        </button>

        
      </div>
    </div>
  );
};

export default MachineInfo;
